export class Estimate {
    estimateId: string = '';
    estimateName: string = '';
    description: string = '';
    owner: string = '';
    ownerEmailId: string = '';
    author: string = '';
    authorEmailId: string = '';
    dateCreated: string = '';
    dateModified: string = '';
    sellPrice: string = '';
    gm: string = '';
    collaborative: string = '';
    currentEditor: string = '';
    costApproved: string = '';
    editingSince: string = '';
    salesOfficeId: number = 0;
    currentEditorEmailId: string = '';
}

export class EstimateTableRow extends Estimate {
    isSelected: boolean = false;
}